// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import { API } from '../../utils/APIUtils';
import {
  WS_CLEAR_PENDING,
  WS_GET_LANDING_REQUEST,
  WS_GET_LANDING_SUCCESS,
  WS_GET_LANDING_ERROR,
  WS_DISPLAY_ERROR_LAYER,
} from '../actions';
import type {
  LandingActions,
  GetLandingParams,
  GetLandingResponse,
  GetLandingError,
} from '../types';

import { afterInitRegistration } from './userRegistrationEpics';
import { sendMessage } from './websocketEpics';

const getLandingRequestEpic = (action$: ActionsObservable<LandingActions>, state$: any) =>
  action$.pipe(
    filter(action => action.type === WS_GET_LANDING_REQUEST),
    afterInitRegistration(state$, (actionSend: LandingActions) => {
      if (actionSend.type === WS_GET_LANDING_REQUEST) {
        return sendMessage<GetLandingParams, GetLandingResponse, GetLandingError>({
          ...actionSend.payload,
          method: API.GetLanding,
        }).pipe(
          switchMap((payload) => {
            if (payload.error) {
              const dispatchActions = [
                {
                  type: WS_GET_LANDING_ERROR,
                  payload: payload.error,
                },
                { type: WS_CLEAR_PENDING },
                {
                  type: WS_DISPLAY_ERROR_LAYER,
                  payload: payload.error,
                },
              ];

              return of(...dispatchActions);
            }

            const dispatchActions = [
              {
                type: WS_GET_LANDING_SUCCESS,
                payload: payload.result,
              },
              { type: WS_CLEAR_PENDING },
            ];

            return of(...dispatchActions);
          }),
        );
      }
    }),
  );

export const landingEpics = combineEpics(getLandingRequestEpic);
